(function ($, Drupal)  {
    var table = $('.paragraph .text-formatted table');

    var hasTableContainer = table.parent("table-container").length;

    if(table.length && !hasTableContainer){
        table.wrap("<div class='table-container'></div>");
    }
}(jQuery, Drupal));